export default {
  SET_NOTIFICATION_SEARCH_QUERY(state, query) {
    state.notificationSearchQuery = query;
  },
  SET_NOTIFICATIONS(state, payload) {
    state.notifications = payload.notifications;
    state.pageable = payload.pageable;
  },
  SET_UNREAD_NOTIFICATIONS(state, payload) {
    state.unreadNotifications = payload.unreadNotifications;
    state.pageable = payload.pageable;
    state.unreadCount = payload.unreadCount;
  },
  SET_UNREAD_COUNT(state, payload) {
    state.unreadCount = payload.unreadCount;
  },
  SET_HAS_NEXT(state, payload) {
    state.hasNext = payload.hasNext;
  }
};
